import { Button, Form, Input, message, Image } from "antd";
import React, { useEffect, useState } from "react";
import fourmstyle from "../../styles/fourm.module.scss";
import { AuthenticatorQrForm } from "./AuthenticatorQrForm";
import { AuthenticatorEnableDisable } from "./AuthenticatorEnableDisable";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

function Security2FAHR() {
  // const { isLoggedIn } = useSoulContext();
  const [factorAuthEnable, setFactorAuthEnable] = useState();
  const [showQrScaner, setShowQRScanner] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    const authenticatorEnable: any = localStorage.getItem(
      "authenticatorEnable"
    );
    const showAuthenticatorQR: any = localStorage.getItem(
      "showAuthenticatorQR"
    );
    setFactorAuthEnable(authenticatorEnable);
    setShowQRScanner(showAuthenticatorQR);
    console.log(`2FA Status : ${factorAuthEnable} , Show QR = ${showQrScaner}`);
  }, []);

  return (
    <div className={fourmstyle.fourm_page_wrapper}>
      <div className={fourmstyle.reportpost_wrapper}>
        <div className={fourmstyle.contentBox}>
          <div
            className={classNames(
              fourmstyle["response_txt"],
              fourmstyle["auth"]
            )}
          >
            <Image
              src="/lock.gif"
              width={144}
              height={144}
              alt="done"
              preview={false}
            />
            <h2>Secure with 2-Step Verification</h2>
            <p>
              Enhance your account security with two-factor authentication by
              using a one-time password for safe and secure login
            </p>
          </div>
          {showQrScaner === "true" ? (
            <AuthenticatorQrForm></AuthenticatorQrForm>
          ) : (
            <AuthenticatorEnableDisable factorAuthEnable={factorAuthEnable} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Security2FAHR;
